import {Theme} from '../theme';

import {useTheme as useThemeImpl} from '@emotion/react';

/**
 * @deprecated This implementation uses the old theme system.
 * Use `useAppTheme` from `src/styles` for the new theme system.
 * The new implementation provides updated theme properties and better support for modern styling needs.
 */
export default function useAppTheme(): Theme {
  return useThemeImpl() as Theme;
}
